<template>
  <div
    class="form-container"
  >
    <div>
      <h4>Create An Account</h4>
      <p>Create an account to manage your payments, get order updates and more!</p>
    </div>
    <form
      id="new_customer"
      novalidate="novalidate"
      class="simple_form new_customer new_customer_checkout_form"
      action="/customers"
      accept-charset="UTF-8"
      data-remote="true"
      method="post"
    >
      <input
        name="utf8"
        type="hidden"
        value="✓"
      >
      <input
        type="hidden"
        name="authenticity_token"
        :value="tok"
      >

      <div class="form-group">
        <input
          id="new_customer_email"
          v-validate="{required: true}"
          :placeholder="$t('form.email')"
          class="form-control"
          value=""
          type="email"
          name="customer[email]"
        >
        <div>
          <label
            v-show="errors.has('customer[email]')"
            class="error"
          >
            Please enter a valid email
          </label>
        </div>
      </div>

      <div class="form-group">
        <input
          id="new_customer_password"
          ref="customer[password]"
          v-validate="{ required: true, min: 8, regex:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/}"
          placeholder="Password"
          autocomplete="off"
          :class="[ originPassword.valid ? 'good-job' : '', 'form-control' ]"
          type="password"
          name="customer[password]"
          data-vv-as="password"
          data-vv-validate-on="input"
        >
        <div>
          <label
            v-show="errors.has('customer[password]')"
            class="error"
          >
            {{ errors.first('customer[password]') }}
          </label>
        </div>
        <div>
          <em class="form-req">{{ $t('passwordComplexity') }}</em>
        </div>
      </div>

      <div class="form-group">
        <input
          id="new_customer_password_confirmation"
          v-validate="'required|confirmed:customer[password]'"
          autocomplete="off"
          placeholder="Confirm Password"
          :class="[ confirmedPassword.valid ? 'good-job' : '', 'form-control' ]"
          type="password"
          name="customer[password_confirmation]"
          data-vv-validate-on="input"
          data-vv-as="password"
          @keyup.enter="submit"
        >
        <label
          v-show="errors.has('customer[password_confirmation]')"
          class="error"
        >{{ errors.first('customer[password_confirmation]') }}</label>
      </div>
      <div class="form-group">
        <input
          id="submitBtn"
          type="submit"
          name="commit"
          :value="createAcctBtnText"
          class="btn btn-primary btn-block create-acct-btn"
          data-disable-with="Sign up"
          :disabled="!originPassword.valid || !confirmedPassword.valid"
        >
      </div>
    </form>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate'

export default {
  props: ['tok'],

  data() {
    return {
      disabled: true,
      createAcctBtnText: ''
    }
  },
  computed: mapFields({
    originPassword: 'customer[password]',
    confirmedPassword: 'customer[password_confirmation]'
  }),

  mounted() {
    this.submitText()
  },

  methods: {
    submit() {
      var input = document.getElementById('customer_password_confirmation')
      input.addEventListener('keyup', function(e) {
        if (e.keyCode === 13) {
          document.getElementById('submitBtn').click()
        }
      })
    },
    submitText(){
      let path = document.getElementById('gaPathOverride').dataset.url
      if(path == '/login') {
        this.createAcctBtnText = 'Create Account'
      } else {
        this.createAcctBtnText = 'Create Account & Checkout'
      }
    },
  }
}
</script>
